import React from 'react';
import { Link } from 'react-router-dom';
import servicesData from '../../../data/services-data';
import ctaImage from '../../../assets/img/page/cta-1.jpg';
import image1 from '../../../assets/img/portfolio/portfolio-4.jpg';
// import image2 from '../../../assets/img/portfolio/portfolio-8.jpg';

const ServicesImportSupply = () => {
    return (
        <>
            <div className="services__details section-padding">
                <div className="container">
                    <div className="row">
                        {/* <div className="col-lg-4 columns_sticky">
                            <div className="all__sidebar">                        
                                <div className="all__sidebar-item">
                                    <h4>Our Solutions</h4>
                                    <div className="all__sidebar-item-category">
                                        <ul>
                                            {servicesData.slice(0, 5).map((data, id) => (
                                                <li key={id}><Link to={`/services/${data.id}`}>{data.title}<i className="flaticon-right-up"></i></Link></li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="all__sidebar-item-help mb-25" style={{backgroundImage: `url(${ctaImage})`}}>
                                    <h3>Ready for Your Next Construction?</h3>
                                    <Link className="build_button mt-20" to="/contact-us">Get an Advice<i className="flaticon-right-up"></i></Link>
                                </div>
                                <div className="all__sidebar-item">
                                    <h4>Download</h4>
                                    <div className="all__sidebar-item-download">
                                        <ul>
                                            <li><Link to="#">Company Details<span className="fal fa-arrow-to-bottom"></span></Link></li>
                                            <li><Link to="#">Our Brochures<span className="fal fa-arrow-to-bottom"></span></Link></li>
                                        </ul>                            
                                    </div>
                                </div>
                            </div>  
                        </div> */}
                        <div className="col-lg-12">
                            <div className="services__details-area">
                                {/* <img src={singleData.image} alt="image" /> */}
                                {/* <h3 className="mt-25 mb-20">{servicesData.title}</h3> */}
                                
                                <h2 className="mb-20">Import &amp; Supply Services at <span style={{color: "#007bff"}}>The Engineersbay Ltd</span></h2>
                                <p className="mb-20">
                                    At The Engineersbay Ltd, we specialize in the import and supply of premium-quality construction materials, ensuring that every project—big or small—has access to reliable resources. With our strong network of local and international partners, we provide a steady flow of certified, durable, and cost-effective materials that meet global standards.
                                </p>

                                <h3 className="mb-20">What We Supply</h3>
                                <ul className="mb-20">
                                    <li><strong>Cement &amp; Aggregates</strong> – High-grade cement, sand, and stone chips for strong foundations.</li>
                                    <li><strong>Steel &amp; Rebars</strong> – Imported and locally sourced reinforcement steel for structural durability.</li>
                                    <li><strong>Bricks &amp; Blocks</strong> – Quality-tested bricks, hollow blocks, and alternative eco-friendly options.</li>
                                    <li><strong>Finishing Materials</strong> – Tiles, paints, glass, and fixtures for interiors and exteriors.</li>
                                    <li><strong>Construction Equipment &amp; Accessories</strong> – Safety gear, tools, and specialized equipment.</li>
                                </ul>

                                <h3 className="mb-20">Our Commitment</h3>
                                <p className="mb-20">
                                    We understand that construction projects demand consistency, quality, and speed. That’s why we not only supply materials but also provide expert guidance in material selection, bulk procurement, and cost optimization. From residential projects to mega infrastructure developments, we support clients with dependable supply solutions tailored to their needs.
                                </p>
                                <p className="mb-20">
                                    <strong>Partner with The Engineersbay Ltd and build with confidence.</strong>
                                </p>

                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>          
        </>
    );
};

export default ServicesImportSupply;